/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { FragmentSourceDto } from "./FragmentSourceDto";
import type { MediaUrlSourceDto } from "./MediaUrlSourceDto";
import type { UploadCancelledDataDto } from "./UploadCancelledDataDto";
import type { UploadCompletedDataDto } from "./UploadCompletedDataDto";
import type { UploadFailedDataDto } from "./UploadFailedDataDto";
import type { UploadInProgressDataDto } from "./UploadInProgressDataDto";
import type { UploadPlatformFeaturesDto } from "./UploadPlatformFeaturesDto";
import type { UploadScheduledDataDto } from "./UploadScheduledDataDto";
import type { UploadWaitingChildrenDataDto } from "./UploadWaitingChildrenDataDto";
import type { UploadWaitingDataDto } from "./UploadWaitingDataDto";
import type { VideoEditorEditSourceDto } from "./VideoEditorEditSourceDto";

export const UploadDtoPlatformEnum = {
    YOUTUBE: "YOUTUBE",
    TWITTER: "TWITTER",
    INSTAGRAM: "INSTAGRAM",
    DAILYMOTION: "DAILYMOTION",
    FACEBOOK: "FACEBOOK",
    DEMO: "DEMO",
    TIKTOK: "TIKTOK"
} as const;

export type UploadDtoPlatformEnumKey = (typeof UploadDtoPlatformEnum)[keyof typeof UploadDtoPlatformEnum];

export const UploadDtoStatusEnum = {
    SCHEDULED: "SCHEDULED",
    WAITING: "WAITING",
    WAITING_CHILDREN: "WAITING_CHILDREN",
    IN_PROGRESS: "IN_PROGRESS",
    COMPLETED: "COMPLETED",
    FAILED: "FAILED",
    CANCELLED: "CANCELLED"
} as const;

export type UploadDtoStatusEnumKey = (typeof UploadDtoStatusEnum)[keyof typeof UploadDtoStatusEnum];

export type UploadDto = {
    /**
     * @type string
    */
    id: string;
    /**
     * @type string
    */
    platform: UploadDtoPlatformEnumKey;
    /**
     * @type string
    */
    clientId: string;
    /**
     * @type string
    */
    stationId: string;
    /**
     * @type string
    */
    createdBy: string;
    /**
     * @type string
    */
    key: string;
    source: (MediaUrlSourceDto | FragmentSourceDto | VideoEditorEditSourceDto);
    data: (UploadScheduledDataDto | UploadWaitingDataDto | UploadWaitingChildrenDataDto | UploadInProgressDataDto | UploadCompletedDataDto | UploadFailedDataDto | UploadCancelledDataDto);
    /**
     * @type object
    */
    publishData: {
        [key: string]: any;
    };
    /**
     * @type string
    */
    createdAt: string;
    /**
     * @type string
    */
    status: UploadDtoStatusEnumKey;
    /**
     * @type boolean
    */
    isPending: boolean;
    /**
     * @description Platform-specific features (manage URL, public URL, deletability)
    */
    platformFeatures?: UploadPlatformFeaturesDto;
};